import { render, staticRenderFns } from "./ProductZoomGalleryItem.vue?vue&type=template&id=1652041a&scoped=true&"
import script from "./ProductZoomGalleryItem.vue?vue&type=script&lang=js&"
export * from "./ProductZoomGalleryItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductZoomGalleryItem.vue?vue&type=style&index=0&id=1652041a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1652041a",
  null
  
)

export default component.exports